import Msg from './src/msg.vue';
import { SFCWithInstall } from '@touchvue/utils';
declare const ToMsg: SFCWithInstall<typeof Msg>;
export * from './src/instance';
export interface MsgOptions {
    title?: string;
    content?: string;
    pic?: string;
    picPosition?: string;
    position?: string;
    height?: string | number;
    confirmButtonText?: string;
    cancelButtonText?: string;
    global?: boolean;
    show?: boolean;
    [key: string]: any;
}
export declare const $msg: {
    (...args: any[]): Promise<boolean>;
    success(options: MsgOptions): Promise<boolean>;
    error(options: MsgOptions): Promise<boolean>;
    help(options: MsgOptions): Promise<boolean>;
    loading(options: MsgOptions): Promise<boolean>;
    info(options: MsgOptions): Promise<boolean>;
    confirm(options: MsgOptions): Promise<boolean>;
};
export default $msg;
export { ToMsg };
